export enum EPlatformNoticePriorityType {
  Low = "Low",
  Normal = "Normal",
  High = "High",
  Critical = "Critical",
}
